module.exports = __webpack_public_path__ + "static/content-wordpress-2-5b26f5e2e3a01ddec6902674606368e8.jpg";